module.exports = __webpack_public_path__ + "img/click.d29a187f.png";